import { useCallback, useEffect, useMemo, useState ,useRef, useContext} from "react";
import IndiaDataGrid from "../../include/IndiaDataGrid";
import { Box, Button, Container, Typography, useMediaQuery} from "@mui/material";
import { GridToolbarColumnsButton, GridToolbarExportContainer, GridToolbarQuickFilter } from "@mui/x-data-grid";
import { Diversity3 } from "@mui/icons-material";
import CampaignAddModal from "../../components/modal/CampaignAddModal";
import { useNavigate } from "react-router-dom";
import { callPostApi } from "../../function/ApiCallFunction";
import GradientLoader from "../../components/CommanComponents/GradientLoader";
import CustomFooterWithLoadMore from "../../include/footerWithLoadMore";
import { DataContext } from "../../context/DataContext";

export function TotalPlusCustomer() 
{
    const navigate = useNavigate();
    const isMobile = useMediaQuery("(max-width:768px)");

    const {loginData }  = useContext(DataContext);
    const store_id      = loginData?.store_info?.store_id; 
  
    /* ===================== STATES ===================== */
    const [allData,        setAllData]        = useState([]);
    const [loading,        setLoading]        = useState(false);
    const [pageIndex,      setPageIndex]      = useState(0);
    const [hasMoreData,    setHasMoreData]    = useState(true);
    const [filtersApplied, setFiltersApplied] = useState(false);
    const [filtersLoaded,  setFiltersLoaded]  = useState(false);
    
    const [open, setOpen] = useState(false);
  
    const isInitialSessionLoad = useRef(false);
    const hasFetchedRef        = useRef(false);

    /** Default filters */
    const defaultFilters = useMemo(() => ({store_id, custType:'', fetchLimit: "10",pageSize: "10",}),[store_id]);
    const [filters, setFilters] = useState(defaultFilters);

    /* ===================== RESET ===================== */
    const resetDataStates = () => 
    {
        setAllData([]);
        setPageIndex(0);
        setHasMoreData(true);
        setLoading(false);
    };

    /* ===================== APPLY FILTER ===================== */
    const applyFilters = () => 
    {
        setAllData([]);
        setPageIndex(0);
        setHasMoreData(true);
        setFiltersApplied(true);
    };

    /* ===================== CLEAR FILTER ===================== */
    const clearFilters = () => 
    {
        setFilters(defaultFilters);
        setAllData([]);
        setPageIndex(0);
        setHasMoreData(true);
        sessionStorage.setItem('cashiPlusCustLst', JSON.stringify(defaultFilters));
        setFiltersApplied(true);
    };
  
    /* ===================== LOAD FROM SESSION ===================== */
    useEffect(() => 
    {
      const storedState = sessionStorage.getItem("cashiPlusCustLst");
      if (storedState) 
      {
          try 
          {
              const parsedState = JSON.parse(storedState);
              setFilters({ ...defaultFilters, ...parsedState });
              isInitialSessionLoad.current = true;
              setFiltersApplied(true);
          } 
          catch { sessionStorage.removeItem("cashiPlusCustLst"); }
      }
    }, [defaultFilters]);

    /* ===================== FETCH API ===================== */
    const fetchData = useCallback(async (page = pageIndex) => 
    {
        if (!filtersLoaded || loading || !hasMoreData) return;
  
        setLoading(true);
        try 
        {
            const StartNum = page * Number(filters.fetchLimit);
            const payload = {mod: "CASHI_PLUS_CUSTOMER",data_arr: {...filters,start: StartNum,limit: filters.fetchLimit,}};
            const response = await callPostApi("cashi-customer", payload);
  
            if (response.status === "200" && response.data ) 
            {
                const apiResponse = response.data;
  
                if (apiResponse.length > 0) 
                {
                  setAllData(prev => [...prev, ...apiResponse]);
                  setPageIndex(page);
                } 
                else {  setHasMoreData(false); }
  
                if (apiResponse.length < filters.fetchLimit) { setHasMoreData(false); }
  
            } else { setHasMoreData(false); }
        } 
        catch { setHasMoreData(false); } 
        finally { setLoading(false); }
  
      },[filters, filtersLoaded, loading, hasMoreData, pageIndex]);
  
    /* ===================== INITIAL LOAD ===================== */  
    // Initial fetch trigger
    useEffect(() => {
        if (!hasFetchedRef.current && filtersLoaded) {
            hasFetchedRef.current = true;
            fetchData();
        }
    }, [filtersLoaded, fetchData]);
  
    // Save to sessionStorage
    useEffect(() => {
        if (filtersApplied) 
        {
            sessionStorage.setItem('cashiPlusCustLst', JSON.stringify(filters));
            if (!isInitialSessionLoad.current) { fetchData(0); }
            isInitialSessionLoad.current = false;
            setFiltersApplied(false);
        }
    }, [filtersApplied, filters, fetchData]);
  
    // Set filters loaded once
    useEffect(() => { if (!filtersLoaded) setFiltersLoaded(true); }, [filtersLoaded]);

    const CustomToolbar = () => (
      <GridToolbarExportContainer sx={{ justifyContent: "space-between", px: 2 }}>
        <GridToolbarColumnsButton />
        <GridToolbarQuickFilter debounceMs={300} />
      </GridToolbarExportContainer>
    );

    const customerTypes = ["PLUS", "REGULAR", "VIP"];
    const fetchLimits    = [ "5", "10", "20", "50", "100", "250", "500", "1000"];
  
  return (
    <Container maxWidth="xl" sx={{ my: 2 }}>

      {/* Buttons */}
      <Box sx={{ display: "flex", mb: 2 }}>
          <Button variant="contained" sx={{ background: "#1976d2" }} onClick={() => navigate(-1)} > Back</Button>
          <Button sx={{ml: "auto",background: "linear-gradient(195deg, #42424a, #191919)",color: "#fff",}}onClick={clearFilters}>Clear Filters</Button>
      </Box>


      {/* Title */}
      <Typography  variant="h6" gutterBottom sx={{ background: 'linear-gradient(195deg, #49a3f1, #1A73E8)', p: 1, color: '#ffffff',
          borderRadius: '4px', mb: 3, display: 'flex', alignItems: 'center' }} > <Diversity3 sx={{ mr: 1 }} /> Total Customer
      </Typography>

      {/* Filters */}
      <div className='mb-3'>
          <div className="row align-items-center g-2 searchFilter">
              
              <div className="col-12 col-md-2">
                  <select className="form-control" value={filters.custType} onChange={(e) => setFilters(prev => ({ ...prev, custType: e.target.value }))} >
                      <option value="">Record Fetch Limit</option>
                      {customerTypes.map(value => ( <option key={value} value={value}>{value}</option>))}
                  </select>
              </div>

              {/* Page Size Filter */}  
              <div className="col-12 col-md-2">
                  <select className="form-control" value={filters.fetchLimit} onChange={(e) => setFilters(prev => ({ ...prev, fetchLimit: e.target.value }))} >
                      <option value="">Record Fetch Limit</option>
                      {fetchLimits.map(value => ( <option key={value} value={value}>{value}</option>))}
                  </select>
              </div>  

              {/* Apply flter */}
              <div className="col-12 col-md-2 ms-auto">                                        
                  <Button  sx={{background:'linear-gradient(195deg, #49a3f1, #1A73E8)', color:'#ffffff',ml:1,
                      boxShadow: 'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px' }}
                          style={{float: 'right'}}  onClick={() => { resetDataStates(); applyFilters(); }} >Apply Filters</Button>
              </div>  
              
          </div>
      </div>

      {/* DataGrid */}
      <Box sx={{ height: 'auto', width: '100%' }}>
          <IndiaDataGrid rows={allData.map((row, i) => ({...row,srNo: i + 1 ,id: row.row_temp_id || `${pageIndex}-${i}`}))}
              columns={[
              { field: "srNo",            headerName: "Sr No.",           flex: isMobile ? undefined : 0.4,},
              { field: 'customer_name',   headerName: 'Customer Name',    flex: isMobile ? undefined : 1,},
              { field: 'cust_type',       headerName: 'Customer Type',    flex: isMobile ? undefined : 1,},
              { field: 'customer_mobile', headerName: 'Customer Contact', flex: isMobile ? undefined : 1,},
              { field: 'customer_email',  headerName: 'Customer Email',   flex: isMobile ? undefined : 1.5,},
            ]}

            localeText={{ noRowsLabel: "No records found", noResultsOverlayLabel: "No matching data found", }}
            pageSize={Number(filters.pageSize)}
              onPageSizeChange={(newSize) => setFilters((prev) => ({ ...prev, pageSize: String(newSize) })) }
              pageSizeOptions={[10, 15, 20, 25, 40, 50, 80, 100]}
              pagination
              disableSelectionOnClick
              initialState={{ pagination: {paginationModel: {pageSize: Number(filters.pageSize),page: 0,},},
                  columns: {columnVisibilityModel: { }}
              }}
              slots={{toolbar: CustomToolbar, footer: () => ( <CustomFooterWithLoadMore onLoadMore={() => fetchData(pageIndex + 1)} hasMoreData={hasMoreData} loading={loading} /> ), }}
              slotProps={{toolbar: {showQuickFilter: true,quickFilterProps: { debounceMs: 300 },},}}
              sx={{ '& .MuiDataGrid-cell': {fontSize: '13px', }, 
                    '& .MuiDataGrid-columnHeaderTitle': {fontSize: '15px',fontWeight: 'bold', whiteSpace: 'normal !important', 
                          lineHeight: '1.5', textAlign: 'center',},
                    "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {outline: "none"} }}
              rowHeight={38} headerHeight={45}
        />
      </Box>

      {/* Add Campaign Dialog */}
      <CampaignAddModal open={open} onClose={() => setOpen(false)} />
      {loading && <GradientLoader text="Loading" />}
      {/* Detail Dialog */}
     
    </Container>
  );
}
